// components/system/PublisherClassSelector.jsx
import React from 'react';
import { PUBLISHER_CLASSES } from '../../constants/systemConstants';

const PublisherClassSelector = ({ 
    selectedClasses, 
    onSelectionChange, 
    disabled = false,
    staleClasses = [] 
}) => {
    const handleClassToggle = (className, isChecked) => {
        if (isChecked) {
            onSelectionChange([...selectedClasses, className]);
        } else {
            onSelectionChange(selectedClasses.filter(c => c !== className));
        }
    };

    const handleSelectAll = () => {
        if (selectedClasses.length === PUBLISHER_CLASSES.ALL.length) {
            // Deselect all
            onSelectionChange([]);
        } else {
            // Select all
            onSelectionChange([...PUBLISHER_CLASSES.ALL]);
        }
    };

    const allSelected = selectedClasses.length === PUBLISHER_CLASSES.ALL.length;
    const noneSelected = selectedClasses.length === 0;

    return (
        <div>
            <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-medium text-gray-700">
                    Publisher Classes to Refresh:
                </label>
                <button
                    type="button"
                    onClick={handleSelectAll}
                    disabled={disabled}
                    className="text-xs text-blue-600 hover:text-blue-800 disabled:opacity-50"
                >
                    {allSelected ? 'Deselect All' : 'Select All'}
                </button>
            </div>
            
            <div className="grid grid-cols-2 gap-2">
                {PUBLISHER_CLASSES.ALL.map(className => {
                    const isStale = staleClasses.includes(className);
                    
                    return (
                        <label 
                            key={className} 
                            className={`flex items-center space-x-2 p-2 rounded border cursor-pointer hover:bg-gray-50 ${
                                selectedClasses.includes(className) 
                                    ? 'border-blue-300 bg-blue-50' 
                                    : 'border-gray-200'
                            } ${
                                isStale ? 'ring-2 ring-yellow-200 bg-yellow-50' : ''
                            }`}
                        >
                            <input
                                type="checkbox"
                                checked={selectedClasses.includes(className)}
                                onChange={(e) => handleClassToggle(className, e.target.checked)}
                                disabled={disabled}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                            <div className="flex-1 min-w-0">
                                <span className="text-sm font-medium text-gray-900 truncate block">
                                    {className}
                                </span>
                                {isStale && (
                                    <span className="text-xs text-yellow-600 bg-yellow-100 px-1.5 py-0.5 rounded-full mt-1 inline-block">
                                        needs refresh
                                    </span>
                                )}
                            </div>
                        </label>
                    );
                })}
            </div>
            
            {/* Selection Summary */}
            <div className="mt-2 text-xs text-gray-600">
                {noneSelected ? (
                    <span className="text-orange-600">No classes selected</span>
                ) : (
                    <span>
                        {selectedClasses.length} of {PUBLISHER_CLASSES.ALL.length} classes selected
                    </span>
                )}
            </div>
        </div>
    );
};

export default PublisherClassSelector;